import angular from "angular";
import { addNotification } from "common/notifications";

angular.module("ticketco/common").service("HelpersService", HelpersService);

function HelpersService($q, growl) {
  this.confirmP = function (message) {
    return function (data) {
      return $q(function (resolve, reject) {
        if (confirm(message)) {
          return resolve(data);
        }
        return reject();
      });
    };
  };

  this.startsWith = function (test, str) {
    return String(str).indexOf(test) === 0;
  };

  this.findByProp = function (prop, val, arr) {
    var i = arr.length;
    var result;
    while (i--) {
      if (arr[i][prop] === val) {
        result = arr[i];
        break;
      }
    }
    return result;
  };

  this.showNotification = function showNotification(type, message) {
    return function res(response, options = {}) {
      var newMessage = angular.isFunction(message)
        ? message(response)
        : message;

      addNotification({
        description: newMessage,
        type: type,
        duration: 15000,
        ...options,
      });
      // growl[type](newMessage, options);
      return response;
    };
  };

  var not = (this.not = function (x) {
    return !x;
  });

  var empty = (this.empty = function (x) {
    return x === undefined || x === null;
  });

  var notEmpty = (this.notEmpty = function (x) {
    return not(empty(x));
  });

  var prop = (this.prop = function (prop, obj) {
    return obj[prop];
  });

  this.T = function () {
    return true;
  };

  this.F = function () {
    return false;
  };
}
